import { ReactComponent as SpinnerIcon } from  "../../assets/images/ic-loader-large.svg"
export default function Loader() {
	return (
		<div className="flex items-center justify-center h-full">
			<SpinnerIcon className="animate-spin" />
		</div>
	)
}
